module.exports = __webpack_public_path__ + "Banner_ChefsKitchen-3447658edd9c361faceb513a1a28c702.svg";